import { NavBar } from 'components/NavBar/NavBar'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import {
    Flex,
    MainHeadline,
    PageFooter,
    PageWrapper,
    Table,
    Th,
    Tr,
} from 'styling/GlobalStyles'
import { Pagination } from 'components/Pagination/Pagination'
import { formatDateForDisplay, formatNumbersForDisplay, getParams, handlePagination } from 'utils/helpers'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import useQueryPagination from 'hooks/useQueryPagination'
import { clearFuelLosses, getFuelLosses } from 'features/fuelManagement/fuelManagementSlice'
import { Td } from 'components/Td/Td'

export const FuelLosses = () => {
    const [params, setParams] = useState<any>(getParams({ location }))
    const { fuelLosses } = useSelector((store: RootState) => store.fuelManagement)

    useQueryPagination({ fetchFunctions: [getFuelLosses], cleanUpFunctions: [clearFuelLosses], params })

    return (
        <>
            <PageWrapper>
                <NavBar />
                <Flex between mb='16' >
                    <MainHeadline>Fuel Losses</MainHeadline>

                </Flex>
                {!fuelLosses?.data?.length ? (
                    <NoItems title='Fuel Losses' />
                ) : (
                    <Table width='100%' >
                        <Th next>
                            <Td w='20%' noTooltip text='DATE' />
                            <Td w='20%' noTooltip text='AMOUNT' />
                            <Td w='20%' noTooltip text='TANK' />
                            <Td w='20%' noTooltip text='BATCH' />
                            <Td w='20%' noTooltip text='TYPE' />
                            <Td w='20%' noTooltip text='CATEGORY TYPE' />
                            <Td w='20%' noTooltip text='TRIGGER' />
                        </Th>
                        {fuelLosses?.data.map((item) => {
                            return (
                                <Tr key={item.id}>
                                    <Td w='20%' text={formatDateForDisplay(item.date)} />
                                    <Td w='20%' noTooltip text={formatNumbersForDisplay(item.amount)} />
                                    <Td w='20%' noTooltip text={item.tank?.name || '/'} />
                                    <Td w='20%' noTooltip text={item?.batch ? formatDateForDisplay(item.batch?.date) : '-'} />
                                    <Td w='20%' noTooltip text='Residual' />
                                    <Td w='20%' noTooltip text='Operational' />
                                    <Td w='20%' noTooltip text='Batch Close' />
                                </Tr>
                            )
                        })}
                    </Table>
                )}


            </PageWrapper>
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams)}
                    pageCount={Math.ceil(fuelLosses.totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        </>
    )
}
